// Only prod builds talk to the production API
const IS_BETA = import.meta.env.MODE !== 'production';

const API_URL = IS_BETA ? 'https://stage-api.verdocs.com' : 'https://api.verdocs.com';

export const CONFIG = {
  IS_BETA,
  API_URL,
  // Platform MCP endpoint, shown to users in the connection snippets after a token is created.
  MCP_URL: `${API_URL}/v2/mcp`,
  PERSONAL_ORGID: '65b59646-64fe-48df-850f-05887ddf003b',
  // Public workflows Worker (brand-preview fetch for Match My Web Site). One instance
  // serves all environments.
  WORKFLOWS_URL: 'https://verdocs-workflows.verdocs.workers.dev',
};
